import { createReducer, on } from '@ngrx/store';
import * as CutVideoActions from '../actions/cut-video.actions';
import {Clip} from '../../../services/api/clips/clip.model';

export const cutVideoFeatureKey = 'cutVideo';

export interface State {
  record: Clip;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(CutVideoActions.cutVideo, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(CutVideoActions.cutVideoSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(CutVideoActions.cutVideoFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(CutVideoActions.clearCutVideoState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
